import React from "react";
import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
  size?: "small" | "medium" | "large";
}

export const Spinner: React.FC<SpinnerProps> = ({
  className,
  size = "medium",
}) => {
  const sizeClass = {
    small: "h-4 w-4",
    medium: "h-6 w-6",
    large: "h-8 w-8",
  }[size];

  return (
    <div
      className={cn("animate-spin text-muted-foreground", sizeClass, className)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
